import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ZenithComponentsModule } from '@mateco/zenith-webcomponents-angular/dist/zenith-webcomponents-angular';
import { NavigationComponent } from './navigation/navigation.component';
import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors } from '@angular/common/http';
import { deviceTimeZoneInterceptorFn } from '../core/interceptors/device-time-zone.interceptor';
import { impersonationInterceptorFn } from '../core/interceptors/impersonation.interceptor';
import { TranslateModule } from '@ngx-translate/core';
import { DriverNameIdInterceptor } from '../core/interceptors/driver-name-id.interceptor';

@NgModule({
  declarations: [NavigationComponent],
  exports: [NavigationComponent],
  imports: [CommonModule, RouterModule, ZenithComponentsModule, TranslateModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DriverNameIdInterceptor,
      multi: true
    },
    provideHttpClient(withInterceptors([deviceTimeZoneInterceptorFn, impersonationInterceptorFn]))
  ]
})
export class BaseModule {}
